<!--
component: ListPrint
author: Ken Nakamura
description: 印刷対象概要書リスト
-->
<template>
  <section>
    <v-container fluid>
      <v-row>
        <v-col>
          <h2 style="text-align: center; margin: 0.5em;">
            以下の概要書が印刷予約されています（全{{pageCount}}ページ）
          </h2>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12">
        <v-data-table
          :headers="headers" :items="kenkaku"
          :fixed-header="true" height="calc(100vh - 22em)"
          disable-pagination hide-default-footer
          :single-select="true" item-key="daichoId"
        >
        <!--
          v-model="selectedId"
        -->
          <template v-slot:body="{ items }">
            <tbody>
              <tr v-for="(item, index) in items"
                @click="selectRow(item)"
                :key="index"
                :class="{selected:item.active}"
                class="default"
              >
                <td>{{item.ukeNo}}</td>
                <td>{{item.kknnNo}}</td>
              </tr>
            </tbody>
          </template>
        </v-data-table>
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <h4 v-show="limitOver" style="text-align: center; margin: 0.5em;">
            一度に印刷できる概要書は{{multiPrintLimit}}枚までです。
          </h4>
          <h4 style="text-align: center; margin: 0.5em;">
            予約を取り消すには、上のリストで取り消したい概要書番号を選択してください。
          </h4>
        </v-col>
      </v-row>
      <v-row style="padding-left:10mm;">
        <v-col cols=4>
          <v-btn large class="primary text-h5" width="90%"
            @click="print" :disabled="loading" :loading="loading">
            印 刷
          </v-btn>
        </v-col>
        <v-col cols=4>
          <v-btn large class="text-h7" width="100%"
            @click="cancelRow" :disabled="selectedId.length==0">
            選択された概要書の印刷をキャンセル
          </v-btn>
        </v-col>
        <v-col cols=4>
          <v-btn large class="text-h7" width="90%"
            @click="suspend" :disabled="loading || limitOver">
            今は印刷せず閲覧画面に戻る
          </v-btn>
        </v-col>
      </v-row>
    </v-container>
  </section>
</template>

<script>
import { dbglog } from '../common/utils'

export default {
  data: () => {
    return {
      loading: false,
      selectedItem: null,
      selectedId: '',
      headers: [
        {
          text: '受付番号',
          value: 'ukeNo'
        },
        {
          text: '確認番号',
          value: 'kknnNo'
        },
        /*
        {
          text: 'ページ数',
          value: 'pageCount'
        },
        */
      ],
    }
  },
  mounted () {
    if (this.unauthorized) {
      this.message = 'ユーザー認証されていません。';
      this.$router.replace('/');
    }
  },
  computed: {
    token () {
      return this.$store.state.token;
    },
    unauthorized () {
      return this.token == undefined || this.token == null || this.token.length == 0;
    },
    authorized () {
      return !this.unauthorized;
    },
    message: {
      get() { return this.$store.state.message; },
      set(val) { this.$store.commit('setMessage', val) }
    },
    kenkaku () {
      const arr = this.$store.state.printList;
      try {
        if (arr === null || !arr.length) {
          return [];
        }
        else {
          //return arr.sort((a, b) => a.ukeNo > b.ukeNo ? 1 : -1);
          return arr;
        }
      }
      catch (err) {
        dbglog(`ListPrint.kenkaku: ${err}`, -1);
        return [];
      }
    },
    pageCount () {
      return this.$store.state.printPageCount;
    },
    multiPrintLimit() {
      return this.$store.state.multiPrintLimit;
    },
    limitOver() {
      return this.$store.state.userInfo.authority <= 1
        && this.kenkaku.length >= this.multiPrintLimit;
    }
  },
  methods: {
    /**
     * 一覧でクリックされた行を選択
     * @param {GaiyoSummary} target 選択する概要データ
     */
    selectRow (target) {
      dbglog(`ListPrint.selectRow(${target.daichoId})`);
      this.selectedItem = target;
      this.selectedId = target.daichoId;
      this.kenkaku.forEach((k) => {
        k.active = (k === target);
      });
    },
    cancelRow() {
      this.$store.commit('removePrintList', this.selectedItem);
      this.selectedId = '';
    },
    print () {
      this.$store.commit('setPrinting', true);
      /* test
      const gaiyo = this.$store.state.gaiyoData;
      this.$router.replace({name:'browse-build', params:{gaiyo:gaiyo,print:true}});
      */
      this.$router.replace('print');
      //this.$store.commit('setPrinting', false);
    },
    suspend () {
      this.$router.back();
    },
  }
}
</script>
<style scoped src="@/styles/table-styles.css">
